'use strict';
const angular = require('angular');

export class WebaccessPickerComponent {
  /*@ngInject*/
  constructor() {
    this.selected = {};
  }

  $onInit() {
    this.config = this.resolve.config;
    this.data = this.config.data;
    this.title = this.config.title || 'Web Access Select';

    this.checkAll();
  };

  checkAll() {
    this.data.forEach(wa => this.selected[wa._id] = true);
  }

  uncheckAll() {
    this.data.forEach(wa => this.selected[wa._id] = false);
  }

  getSelectedCount() {
    return this.data.filter(wa => this.selected[wa._id]).map(wa => wa._id).length;
  }

  ok() {
    let selectedData = this.data.filter(wa => this.selected[wa._id]).map(wa => wa._id);
    this.close({$value: selectedData});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.webaccessPicker', [])
  .component('webaccessPicker', {
    template: require('./webaccess-picker.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: WebaccessPickerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/webaccess-picker/webaccess-picker.component.js